export default "__VITE_ASSET__07976429__"